<!-- Sidebar -->
<aside
  class="min-w-67.5 max-w-[320px] bg-white border-r border-slate-200 2xl:flex flex-col h-full hidden"
>
  <div class="p-4 flex flex-col gap-4">
    <ng-container *ngTemplateOutlet="navbarHeader"></ng-container>
    <ng-container *ngTemplateOutlet="navbar"></ng-container>
  </div>
</aside>

<!-- Mobile Drawer -->
<p-drawer [(visible)]="drawerOpen" (visibleChange)="drawerOpenChange.emit($event)" position="left">
  <ng-template #header>
    <ng-container *ngTemplateOutlet="navbarHeader"></ng-container>
  </ng-template>
  <ng-container *ngTemplateOutlet="navbar"></ng-container>
</p-drawer>

<!-- Navbar Template -->
<ng-template #navbar>
  <nav class="space-y-1">
    <a
      routerLink="/dashboard"
      routerLinkActive="bg-primary text-gray-50! hover:bg-primary!"
      class="flex items-center gap-3 px-4 py-2.5 rounded-lg text-slate-700 hover:bg-primary/10 transition-all"
    >
      <i class="pi pi-th-large text-sm"></i>
      <span class="font-medium text-sm">Dashboard</span>
    </a>
    <a
      routerLink="/import"
      routerLinkActive="bg-primary text-gray-50! hover:bg-primary!"
      class="flex items-center gap-3 px-4 py-2.5 rounded-lg text-slate-700 hover:bg-primary/10 transition-all"
    >
      <i class="pi pi-calendar-plus text-sm"></i>
      <span class="font-medium text-sm">Import New Data</span>
    </a>
  </nav>
</ng-template>

<!-- Navbar Header Template -->
<ng-template #navbarHeader>
  <div class="flex items-center gap-3 font-bold text-lg leading-tight text-primary">
    <div class="flex justify-center my-3">
      <img src="assets/images/asset-logo.png" alt="Accrete Consulting" class="" />
    </div>
  </div>
</ng-template>
